  (() => {
    if (window.BeeProductStoryShareFinalReady) return;
    window.BeeProductStoryShareFinalReady = true;

    const runtime = document.currentScript;
    const mediaUrl = runtime?.dataset.mediabunnySrc;
    const aacUrl = runtime?.dataset.aacSrc;
    const dependencies = new Map();

    function loadDependency(url, ready) {
      if (ready()) return Promise.resolve();
      if (dependencies.has(url)) return dependencies.get(url);
      if (!url) return Promise.reject(new Error('Story dependency URL is missing'));
      const promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const finish = (error) => {
          clearTimeout(timer);
          script.onload = script.onerror = null;
          if (error) {
            script.remove();
            reject(error);
          } else {
            resolve();
          }
        };
        const timer = setTimeout(() => finish(new Error('Story dependency timed out')), 30000);
        script.src = url;
        script.async = true;
        if (runtime?.nonce) script.nonce = runtime.nonce;
        script.onload = () => finish(ready() ? null : new Error('Story dependency failed to initialize'));
        script.onerror = () => finish(new Error('Story dependency could not be loaded'));
        document.head.appendChild(script);
      });
      dependencies.set(url, promise);
      promise.catch(() => dependencies.delete(url));
      return promise;
    }

    let alignmentFrame;

    function alignShareButtons() {
      document.querySelectorAll('[data-product-story-share]').forEach((root) => {
        const wrapper = root.closest('.bee-product__media-wrapper');
        if (!wrapper) return;

        const iconButtons = Array.from(wrapper.querySelectorAll('.bee-pr__icon-btn')).filter((button) => {
          if (root.contains(button)) return false;

          const rect = button.getBoundingClientRect();
          const style = window.getComputedStyle(button);
          return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (!iconButtons.length) {
          root.removeAttribute('data-icon-aligned');
          return;
        }

        const reference = iconButtons.sort((first, second) => {
          const firstRect = first.getBoundingClientRect();
          const secondRect = second.getBoundingClientRect();
          return secondRect.right - firstRect.right || secondRect.bottom - firstRect.bottom;
        })[0];
        const wrapperRect = wrapper.getBoundingClientRect();
        const referenceRect = reference.getBoundingClientRect();

        root.style.setProperty('--bee-story-share-top', `${referenceRect.top - wrapperRect.top}px`);
        root.style.setProperty('--bee-story-share-width', `${referenceRect.width}px`);
        root.style.setProperty('--bee-story-share-height', `${referenceRect.height}px`);
        root.setAttribute('data-icon-aligned', 'true');
      });
    }

    function scheduleShareAlignment() {
      window.cancelAnimationFrame(alignmentFrame);
      alignmentFrame = window.requestAnimationFrame(alignShareButtons);
    }

    function loadImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) {
          reject(new Error('Image URL is empty'));
          return;
        }

        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = new URL(url, window.location.origin).href;
      });
    }

    function roundedRect(context, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + width, y, x + width, y + height, r);
      context.arcTo(x + width, y + height, x, y + height, r);
      context.arcTo(x, y + height, x, y, r);
      context.arcTo(x, y, x + width, y, r);
      context.closePath();
    }

    function drawContain(context, image, x, y, width, height) {
      const scale = Math.min(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      context.drawImage(image, x + (width - renderedWidth) / 2, y + (height - renderedHeight) / 2, renderedWidth, renderedHeight);
    }

    function drawBlob(context, x, y, radius, color) {
      context.save();
      context.fillStyle = color;
      context.beginPath();
      context.arc(x, y, radius, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }

    function drawThinLogo(context, x, y, font) {
      context.save();
      context.textAlign = 'right';
      context.textBaseline = 'middle';
      context.font = `800 31px ${font}`;
      context.fillStyle = '#6f1f30';
      context.fillText('royal.az', x, y);

      context.fillStyle = '#ff7a1a';
      context.beginPath();
      context.arc(x - 145, y, 7, 0, Math.PI * 2);
      context.fill();
      context.restore();
    }

    function textLines(context, text, maxWidth, maxLines) {
      const words = String(text || '').split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      let truncated = false;

      words.forEach((word) => {
        const test = line ? `${line} ${word}` : word;
        if (context.measureText(test).width <= maxWidth || !line) {
          line = test;
        } else if (lines.length < maxLines - 1) {
          lines.push(line);
          line = word;
        } else {
          truncated = true;
        }
      });

      if (line && lines.length < maxLines) lines.push(line);
      if (truncated && lines.length) lines[lines.length - 1] = `${lines[lines.length - 1]}…`;
      return lines;
    }

    function productData(root) {
      const relativeUrl = root.dataset.productUrl || '';
      const title = (root.dataset.productTitle || '').trim();
      let description = (root.dataset.productDescription || '').trim();
      if (title) {
        const escapedTitle = title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        description = description.replace(new RegExp(`^(?:${escapedTitle}\\s*)+`, 'i'), '').trim();
      }
      return {
        mode: root.dataset.storyMode || 'product',
        title,
        description,
        price: (root.dataset.productPrice || '').trim(),
        priceCents: Number(root.dataset.productPriceCents || 0),
        comparePrice: (root.dataset.productComparePrice || '').trim(),
        comparePriceCents: Number(root.dataset.productComparePriceCents || 0),
        image: (root.dataset.productImage || '').trim(),
        audio: (root.dataset.productAudio || '').trim(),
        isPiano: root.dataset.productIsPiano === 'true',
        specs: [
          {
            label: 'KLAVİATURA MEXANİZMİ',
            value: root.dataset.productKeyboardAction || root.dataset.productKeyboardNote || ''
          },
          { label: 'POLİFONİYA', value: root.dataset.productPolyphony || '' },
          { label: 'SƏS MÜHƏRRİKİ', value: root.dataset.productSoundEngine || '' },
          { label: 'SƏS SİSTEMİ', value: root.dataset.productSpeakerSystem || '' }
        ].filter((spec) => spec.value.trim()),
        url: relativeUrl ? new URL(relativeUrl, window.location.origin).href : window.location.href
      };
    }

    function imagePanelMetrics(image, top) {
      const ratio = image && image.width && image.height ? image.width / image.height : 1.35;
      const maxContentWidth = 820;
      const maxContentHeight = 500;
      let contentWidth = maxContentWidth;
      let contentHeight = contentWidth / ratio;

      if (contentHeight > maxContentHeight) {
        contentHeight = maxContentHeight;
        contentWidth = contentHeight * ratio;
      }

      const width = Math.max(480, Math.min(900, contentWidth + 64));
      const height = Math.max(360, Math.min(570, contentHeight + 64));
      const x = (1080 - width) / 2;

      return {
        x,
        y: top,
        width,
        height,
        imageX: x + 28,
        imageY: top + 28,
        imageWidth: width - 56,
        imageHeight: height - 56,
        centerX: 540,
        centerY: top + height / 2,
        bottom: top + height
      };
    }

    function storyText(mode) {
      if (mode === 'audio') return { badge: 'Audio nümunəsi', cta: 'SƏSİNİ DİNLƏ' };
      if (mode === 'video') return { badge: 'Video təqdimatı', cta: 'VİDEOYA BAX' };
      return { badge: 'Məhsulu kəşf et', cta: 'ƏTRAFLI BAX' };
    }

    function monthlyCreditText(priceCents) {
      const price = Number(priceCents || 0) / 100;
      if (!price) return '';

      const creditRate = 23.5;
      const months = 12;
      const total = price + price * creditRate / 100;
      const monthly = total / months;

      return `${monthly.toFixed(2)} ₼ / ${months} ay`;
    }

    function drawCreditPill(context, x, y, text, font) {
      if (!text) return;

      context.save();

      const width = 356;
      const height = 92;
      const centerX = x + width / 2;

      context.shadowColor = 'rgba(65, 104, 75, 0.12)';
      context.shadowBlur = 18;
      context.shadowOffsetY = 8;
      roundedRect(context, x, y, width, height, 28);
      context.fillStyle = '#e9f4eb';
      context.fill();

      context.shadowColor = 'transparent';

      context.fillStyle = '#607366';
      context.font = `800 17px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('KREDİTLƏ AYLIQ', centerX, y + 27);

      context.fillStyle = '#245337';
      context.font = `900 32px ${font}`;
      context.fillText(text, centerX, y + 63);

      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';

      context.restore();
    }

    function drawBadge(context, x, y, label, mode, font) {
      context.save();

      context.font = `800 24px ${font}`;
      const width = context.measureText(label).width + 78;

      roundedRect(context, x, y, width, 54, 27);
      context.fillStyle = mode === 'audio' ? 'rgba(255, 102, 0, .10)' : 'rgba(111, 31, 48, .075)';
      context.fill();
      context.fillStyle = mode === 'audio' ? '#ff6600' : '#6f1f30';
      context.beginPath();
      context.arc(x + 29, y + 27, 15, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#fff';
      context.beginPath();
      context.moveTo(x + 25, y + 19);
      context.lineTo(x + 25, y + 35);
      context.lineTo(x + 38, y + 27);
      context.closePath();
      context.fill();
      context.fillStyle = mode === 'audio' ? '#8a4a12' : '#5f2733';
      context.textBaseline = 'middle';
      context.fillText(label, x + 56, y + 27);
      context.restore();
    }

    function drawSaleBadge(context, x, y, font) {
      const label = 'Endirimdə';

      context.save();

      context.font = `900 23px ${font}`;
      const width = context.measureText(label).width + 66;
      const height = 52;

      context.shadowColor = 'rgba(255, 102, 0, 0.18)';
      context.shadowBlur = 16;
      context.shadowOffsetY = 8;

      const gradient = context.createLinearGradient(x, y, x + width, y + height);
      gradient.addColorStop(0, '#ffad63');
      gradient.addColorStop(1, '#ff6600');

      roundedRect(context, x, y, width, height, 27);
      context.fillStyle = gradient;
      context.fill();

      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;

      context.fillStyle = 'rgba(255, 255, 255, 0.20)';
      context.beginPath();
      context.arc(x + 26, y + 26, 33, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = '#ffffff';
      context.font = `900 18px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('%', x + 27, y + 27);

      context.font = `900 23px ${font}`;
      context.textAlign = 'left';
      context.fillText(label, x + 50, y + 27);

      context.restore();
    }

    function clamp(value, min = 0, max = 1) {
      return Math.min(max, Math.max(min, value));
    }

    function easeOutCubic(value) {
      return 1 - Math.pow(1 - clamp(value), 3);
    }

    function revealAt(seconds, start, duration = 0.8) {
      return easeOutCubic((seconds - start) / duration);
    }

    function lerp(start, end, progress) {
      return start + (end - start) * clamp(progress);
    }

    function easeInOutCubic(value) {
      const progress = clamp(value);
      return progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    }

    function easeOutBack(value) {
      const progress = clamp(value);
      const overshoot = 1.18;
      return 1 + (overshoot + 1) * Math.pow(progress - 1, 3) + overshoot * Math.pow(progress - 1, 2);
    }

    function typedText(text, seconds, start, duration) {
      const value = String(text || '');
      const progress = clamp((seconds - start) / duration);
      return value.slice(0, Math.ceil(value.length * progress));
    }

    function storyFileName(title) {
      const safeTitle = String(title || 'Royal məhsul')
        .replace(/[\\/:*?"<>|%]/g, ' ')
        .replace(/[\u0000-\u001f\u007f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 90);

      return `${safeTitle || 'Royal məhsul'} - 60 FPS Story.mp4`;
    }

    function brandName(title) {
      const firstWord = String(title || 'ROYAL').trim().split(/\s+/)[0] || 'ROYAL';
      return firstWord.replace(/[^\p{L}\p{N}-]/gu, '').toUpperCase().slice(0, 18) || 'ROYAL';
    }

    function saleDetails(product) {
      const current = Number(product.priceCents || 0);
      const previous = Number(product.comparePriceCents || 0);
      if (!current || previous <= current) return null;

      const saving = previous - current;
      return {
        percent: Math.round(saving / previous * 100),
        saving: `${(saving / 100).toFixed(2)} ₼`
      };
    }

    function drawOfferPanel(context, product, x, y, reveal, font) {
      if (!saleDetails(product)) return;

      const width = 530;
      const height = 178;
      const slide = (1 - reveal) * 44;

      context.save();
      context.globalAlpha = reveal;
      context.translate(-slide, 0);

      context.shadowColor = 'rgba(65, 104, 75, 0.12)';
      context.shadowBlur = 22;
      context.shadowOffsetY = 10;
      roundedRect(context, x, y, width, height, 30);
      context.fillStyle = '#edf6ef';
      context.fill();

      context.shadowColor = 'transparent';

      context.fillStyle = '#718077';
      context.font = `800 18px ${font}`;
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      context.fillText('QİYMƏT', x + 28, y + 39);
      context.fillStyle = '#7c8980';
      context.font = `750 29px ${font}`;
      context.fillText(product.comparePrice, x + 28, y + 78);
      const oldWidth = context.measureText(product.comparePrice).width;
      context.beginPath();
      context.moveTo(x + 24, y + 66);
      context.lineTo(x + 38 + oldWidth, y + 66);
      context.strokeStyle = '#9bac9f';
      context.lineWidth = 3;
      context.stroke();

      context.fillStyle = '#244f35';
      context.font = `900 52px ${font}`;
      context.fillText(product.price, x + 28, y + 143);

      context.textBaseline = 'alphabetic';
      context.restore();
    }

    function drawSpecTicker(context, specs, seconds, font) {
      if (!specs || !specs.length || seconds < 2.75) return;

      const itemDuration = 1.45;
      const elapsed = seconds - 2.75;
      const index = Math.min(specs.length - 1, Math.floor(elapsed / itemDuration));
      const local = (elapsed - index * itemDuration) / itemDuration;
      const enter = easeOutBack(local / 0.28);
      const exit = index < specs.length - 1 ? clamp((1 - local) / 0.2) : 1;
      const visibility = clamp(Math.min(local / 0.18, exit));
      const spec = specs[index];

      context.save();
      context.globalAlpha = visibility;
      const x = 72;
      const y = 1372;
      const width = 930;
      const height = 92;
      const scale = lerp(0.965, 1, enter);
      context.translate(x + width / 2, y + height / 2);
      context.scale(scale, scale);
      context.translate(-(x + width / 2), -(y + height / 2));

      roundedRect(context, x, y, width, height, 27);
      context.fillStyle = '#eaf4ec';
      context.fill();

      context.fillStyle = '#65776a';
      context.font = `850 17px ${font}`;
      context.fillText(spec.label, x + 28, y + 35);

      context.fillStyle = '#244f35';
      context.font = `900 26px ${font}`;
      const lines = textLines(context, spec.value, 640, 2);
      lines.forEach((line, lineIndex) => context.fillText(line, x + 260, y + 34 + lineIndex * 29));
      context.restore();
    }

    function drawStoryFrame(context, product, image, seconds) {
      const font = 'Quicksand, sans-serif';
      const ink = '#173d2c';
      const muted = '#5e796b';
      const line = '#d7dfce';
      const headerReveal = revealAt(seconds, 0.12, 0.55);
      const imageReveal = revealAt(seconds, 0.35, 0.9);
      const specs = product.specs || [];
      const hasPianoLayout = product.isPiano && specs.length > 0;
      const panel = imagePanelMetrics(image, hasPianoLayout ? 405 : 390);

      context.clearRect(0, 0, 1080, 1920);
      context.fillStyle = '#f7f4e9';
      context.fillRect(0, 0, 1080, 1920);

      context.save();
      context.globalAlpha = headerReveal;
      context.translate(0, (1 - headerReveal) * -24);
      context.strokeStyle = '#6d927f';
      context.lineWidth = 3;
      context.beginPath();
      context.moveTo(72, 98);
      context.lineTo(98, 98);
      context.stroke();
      context.fillStyle = muted;
      context.font = `600 24px ${font}`;
      context.fillText('Məhsul təqdimatı', 112, 106);
      drawThinLogo(context, 1010, 98, font);
      context.restore();

      const visibleTitle = typedText(product.title || 'Musiqi aləti', seconds, 0.58, 1.0);
      const titleReveal = revealAt(seconds, 0.5, 0.5);
      context.save();
      context.globalAlpha = titleReveal;
      context.fillStyle = ink;
      context.font = `900 67px ${font}`;
      const titleLines = textLines(context, visibleTitle, 830, 2);
      titleLines.forEach((text, index) => context.fillText(text, 72, 245 + index * 72));
      if (seconds > 0.58 && seconds < 1.8 && Math.floor(seconds * 6) % 2 === 0 && titleLines.length) {
        const last = titleLines[titleLines.length - 1];
        const cursorX = 72 + context.measureText(last).width + 10;
        roundedRect(context, cursorX, 193 + (titleLines.length - 1) * 72, 7, 60, 3.5);
        context.fillStyle = '#72947f';
        context.fill();
      }
      context.restore();

      const descriptionStart = hasPianoLayout ? 1.35 : 2.35;
      const visibleDescription = typedText(
        product.description || 'Məhsul haqqında ətraflı məlumatı kəşf et.',
        seconds,
        descriptionStart,
        1.45
      );
      if (hasPianoLayout) {
        context.save();
        context.globalAlpha = revealAt(seconds, descriptionStart, 0.4);
        context.fillStyle = muted;
        context.font = `600 31px ${font}`;
        textLines(context, visibleDescription, 760, 2).forEach((text, index) => {
          context.fillText(text, 72, 315 + index * 43);
        });
        context.restore();
      }

      context.save();
      context.globalAlpha = imageReveal;
      const pop = easeOutBack((seconds - 0.35) / 0.95);
      const camera = easeInOutCubic(seconds / 10);
      const imageScale = lerp(0.965, 1, pop) * lerp(1.025, 1.07, camera);
      const imageX = panel.centerX;
      const imageY = panel.centerY;
      context.translate(imageX, imageY);
      context.scale(imageScale, imageScale);
      context.translate(-imageX, -imageY);
      context.shadowColor = 'rgba(41, 67, 51, 0.10)';
      context.shadowBlur = 34;
      context.shadowOffsetY = 16;
      roundedRect(context, panel.x, panel.y, panel.width, panel.height, 42);
      context.fillStyle = '#ffffff';
      context.fill();
      context.shadowColor = 'transparent';
      context.save();
      roundedRect(context, panel.x, panel.y, panel.width, panel.height, 42);
      context.clip();
      if (image) drawContain(context, image, panel.imageX, panel.imageY, panel.imageWidth, panel.imageHeight);
      context.restore();
      context.restore();

      context.save();
      context.globalAlpha = revealAt(seconds, 1.0, 0.7) * 0.18;
      context.fillStyle = '#6f9a79';
      context.font = `900 142px ${font}`;
      context.translate(1016, 205 + seconds * 10);
      context.rotate(Math.PI / 2);
      context.fillText(brandName(product.title), 0, 0);
      context.restore();

      if (!hasPianoLayout) {
        const descriptionY = panel.bottom + 72;
        context.save();
        const descriptionReveal = revealAt(seconds, descriptionStart, 0.48);
        context.globalAlpha = descriptionReveal;
        context.translate(0, (1 - descriptionReveal) * 24);
        context.fillStyle = muted;
        context.font = `600 31px ${font}`;
        textLines(context, visibleDescription, 900, 3).forEach((text, index) => {
          context.fillText(text, 72, descriptionY + index * 43);
        });
        context.restore();
      }

      const rowStart = panel.bottom + 70;
      const rowHeight = 73;
      if (hasPianoLayout) specs.slice(0, 4).forEach((spec, index) => {
        const reveal = revealAt(seconds, 2.75 + index * 0.32, 0.55);
        const rowY = rowStart + index * rowHeight;
        context.save();
        context.globalAlpha = reveal;
        context.translate((1 - reveal) * 34, 0);
        context.strokeStyle = line;
        context.lineWidth = 2;
        context.beginPath();
        context.moveTo(72, rowY);
        context.lineTo(1008, rowY);
        context.stroke();
        context.fillStyle = muted;
        context.font = `800 18px ${font}`;
        context.fillText(spec.label, 72, rowY + 45);
        context.fillStyle = ink;
        context.font = `800 25px ${font}`;
        context.textAlign = 'right';
        const valueLines = textLines(context, spec.value, 610, 1);
        context.fillText(valueLines[0] || '', 1008, rowY + 46);
        context.textAlign = 'left';
        context.restore();
      });

      const specsBottom = rowStart + Math.min(specs.length, 4) * rowHeight;
      const nonPianoDescriptionBottom = panel.bottom + 72 + 3 * 43;
      const priceY = hasPianoLayout
        ? Math.max(1435, specsBottom + 80)
        : Math.min(1570, nonPianoDescriptionBottom + 100);
      const priceReveal = revealAt(seconds, 5.25, 0.72);
      context.save();
      context.globalAlpha = priceReveal;
      context.translate(0, (1 - priceReveal) * 42);
      const sale = saleDetails(product);
      if (sale && product.comparePrice) {
        context.fillStyle = muted;
        context.font = `600 25px ${font}`;
        context.fillText(product.comparePrice, 72, priceY);
        const oldWidth = context.measureText(product.comparePrice).width;
        context.strokeStyle = '#799485';
        context.lineWidth = 3;
        context.beginPath();
        context.moveTo(70, priceY - 10);
        context.lineTo(79 + oldWidth, priceY - 10);
        context.stroke();
      }
      context.fillStyle = ink;
      context.font = `900 72px ${font}`;
      context.fillText(product.price || '', 72, priceY + 80);
      context.restore();

      const credit = monthlyCreditText(product.priceCents);
      if (credit) {
        const creditReveal = revealAt(seconds, 5.7, 0.65);
        context.save();
        context.globalAlpha = creditReveal;
        const creditScale = lerp(0.92, 1, easeOutBack((seconds - 5.7) / 0.72));
        const creditX = 610;
        const creditY = priceY - 5;
        context.translate(creditX + 198, creditY + 66);
        context.scale(creditScale, creditScale);
        context.translate(-(creditX + 198), -(creditY + 66));
        roundedRect(context, creditX, creditY, 398, 132, 38);
        context.fillStyle = '#e6efdc';
        context.fill();
        context.fillStyle = '#76907f';
        context.font = `600 21px ${font}`;
        context.fillText('Kreditlə aylıq', creditX + 30, creditY + 48);
        context.fillStyle = ink;
        context.font = `800 30px ${font}`;
        context.fillText(credit, creditX + 30, creditY + 91);
        context.restore();
      }

      context.save();
      context.globalAlpha = revealAt(seconds, 7.0, 0.7);
      context.fillStyle = muted;
      context.font = `600 19px ${font}`;
      context.fillText(new URL(product.url).hostname, 72, 1838);
      context.textAlign = 'right';
      context.fillText('Royal · Musiqi alətləri mağazası', 1008, 1838);
      context.textAlign = 'left';
      context.restore();
    }

    async function createStoryAudioBuffer(url, duration) {
      if (!url) return null;

      const AudioContextConstructor = window.AudioContext || window.webkitAudioContext;
      const OfflineAudioContextConstructor = window.OfflineAudioContext || window.webkitOfflineAudioContext;
      if (!AudioContextConstructor || !OfflineAudioContextConstructor) {
        throw new Error('Audio rendering is not supported by this browser');
      }

      const response = await fetch(new URL(url, window.location.origin).href, { mode: 'cors' });
      if (!response.ok) throw new Error('Product audio could not be loaded');

      const decodingContext = new AudioContextConstructor();
      let decoded;
      try {
        decoded = await decodingContext.decodeAudioData(await response.arrayBuffer());
      } finally {
        await decodingContext.close();
      }

      const sampleRate = 44100;
      const channelCount = Math.max(1, Math.min(2, decoded.numberOfChannels));
      const offlineContext = new OfflineAudioContextConstructor(channelCount, sampleRate * duration, sampleRate);
      const source = offlineContext.createBufferSource();
      const gain = offlineContext.createGain();

      source.buffer = decoded;
      source.loop = decoded.duration < duration;
      gain.gain.setValueAtTime(0.0001, 0);
      gain.gain.exponentialRampToValueAtTime(0.92, 0.45);
      gain.gain.setValueAtTime(0.92, duration - 0.8);
      gain.gain.exponentialRampToValueAtTime(0.0001, duration);
      source.connect(gain).connect(offlineContext.destination);
      source.start(0, 0, duration);

      return offlineContext.startRendering();
    }

    async function ensureAacEncoder() {
      if (await window.Mediabunny.canEncodeAudio('aac')) return;
      await loadDependency(aacUrl, () => Boolean(window.MediabunnyAacEncoder));
      if (!window.BeeProductStoryAacEncoderReady) {
        window.MediabunnyAacEncoder.registerAacEncoder();
        window.BeeProductStoryAacEncoderReady = true;
      }
    }

    async function createStoryVideo(product, onProgress) {
      if (typeof window.VideoEncoder !== 'function') {
        throw new Error('Exact 60 FPS export is not supported by this browser');
      }
      await loadDependency(mediaUrl, () => Boolean(window.Mediabunny));

      const duration = 10;
      const audioDuration = duration - 0.1;
      const frameRate = 60;
      const frameCount = duration * frameRate;
      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const context = canvas.getContext('2d', { alpha: false });
      if (!context) throw new Error('Canvas could not be initialized');

      if (document.fonts && document.fonts.load) {
        await Promise.all([
          document.fonts.load('600 31px Quicksand'),
          document.fonts.load('800 30px Quicksand'),
          document.fonts.load('900 72px Quicksand')
        ]);
        await document.fonts.ready;
        if (!document.fonts.check('600 31px Quicksand')) {
          throw new Error('Quicksand fontu yüklənmədi');
        }
      }
      const image = product.image ? await loadImage(product.image).catch(() => null) : null;
      const audioBuffer = await createStoryAudioBuffer(product.audio, audioDuration);
      if (audioBuffer) await ensureAacEncoder();

      const {
        AudioBufferSource,
        BufferTarget,
        CanvasSource,
        Mp4OutputFormat,
        Output,
        Quality
      } = window.Mediabunny;

      const target = new BufferTarget();
      const output = new Output({
        format: new Mp4OutputFormat({ fastStart: 'in-memory' }),
        target
      });
      const videoSource = new CanvasSource(canvas, {
        codec: 'avc',
        quality: new Quality({ bitrate: 7000000 }),
        keyFrameInterval: 2
      });

      output.addVideoTrack(videoSource, { frameRate });

      let audioSource = null;
      if (audioBuffer) {
        audioSource = new AudioBufferSource({
          codec: 'aac',
          quality: new Quality({ bitrate: 192000 })
        });
        output.addAudioTrack(audioSource);
      }

      await output.start();
      if (audioSource) await audioSource.add(audioBuffer);

      for (let frame = 0; frame < frameCount; frame += 1) {
        const seconds = frame / frameRate;
        drawStoryFrame(context, product, image, seconds);
        await videoSource.add(seconds, 1 / frameRate, { keyFrame: frame % (frameRate * 2) === 0 });

        if (frame % 12 === 0) {
          if (onProgress) onProgress((frame + 1) / frameCount);
          await new Promise((resolve) => window.requestAnimationFrame(resolve));
        }
      }

      await output.finalize();
      if (!target.buffer || !target.buffer.byteLength) {
        throw new Error('Video export returned an empty file');
      }

      if (onProgress) onProgress(1);
      return new File([target.buffer], storyFileName(product.title), { type: 'video/mp4' });
    }

    function showStatus(root, message, timeout = 2200) {
      const status = root.querySelector('[data-product-story-status]');
      if (!status) return;

      status.textContent = message;
      window.setTimeout(() => {
        status.textContent = '';
      }, timeout);
    }

    function closeAllMenus() {
      document.querySelectorAll('[data-product-story-menu]:not([hidden])').forEach((menu) => {
        menu.hidden = true;
        const root = menu.closest('[data-product-story-share]');
        const button = root && root.querySelector('[data-product-story-button]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    async function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    function downloadStoryFile(file) {
      window.dispatchEvent(new CustomEvent('royal:story-video-ready', { detail: { file } }));
      const objectUrl = URL.createObjectURL(file);
      const download = document.createElement('a');
      download.href = objectUrl;
      download.download = file.name;
      document.body.appendChild(download);
      download.click();
      download.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    }

    async function handleStoryShareClick(event) {
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!target) return;

      const trigger = target.closest('[data-product-story-button]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const root = trigger.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (!menu) return;

        const willOpen = menu.hidden;
        closeAllMenus();
        menu.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      const option = target.closest('[data-product-share-kind]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();

        const root = option.closest('[data-product-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-product-story-menu]');
        if (menu) menu.hidden = true;

        const triggerButton = root.querySelector('[data-product-story-button]');
        if (triggerButton) triggerButton.setAttribute('aria-expanded', 'false');

        const product = productData(root);
        const kind = option.dataset.productShareKind;
        const text = `${product.title || 'Bu məhsul'} — Royal.az`;

        if (kind === 'instagram') {
          showStatus(root, '60 FPS video hazırlanır: 0%', 120000);
          try {
            option.disabled = true;
            option.setAttribute('aria-busy', 'true');
            const file = await createStoryVideo(product, (progress) => {
              showStatus(root, `60 FPS video hazırlanır: ${Math.round(progress * 100)}%`, 120000);
            });
            window.dispatchEvent(new CustomEvent('royal:story-video-rendered', { detail: { file } }));
            let shared = false;
            if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
              try {
                await navigator.share({ files: [file], title: product.title, text });
                shared = true;
              } catch (shareError) {
                if (shareError && shareError.name === 'AbortError') return;
              }
            }
            if (!shared) {
              downloadStoryFile(file);
              showStatus(root, '60 FPS Story videosu endirildi');
            }
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            console.error('[Royal Story] 60 FPS export failed', error);
            showStatus(root, 'Bu cihazda 60 FPS video hazırlamaq mümkün olmadı', 5000);
          } finally {
            option.disabled = false;
            option.removeAttribute('aria-busy');
          }
        } else if (kind === 'native') {
          if (navigator.share) {
            try {
              await navigator.share({ title: product.title, text, url: product.url });
            } catch (error) {}
          } else {
            try {
              await copyToClipboard(product.url);
              showStatus(root, 'Link kopyalandı');
            } catch (error) {
              window.open(product.url, '_blank', 'noopener');
            }
          }
        } else if (kind === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${product.url}`)}`, '_blank', 'noopener');
        } else if (kind === 'telegram') {
          window.open(`https://t.me/share/url?url=${encodeURIComponent(product.url)}&text=${encodeURIComponent(text)}`, '_blank', 'noopener');
        } else if (kind === 'copy') {
          try {
            await copyToClipboard(product.url);
            showStatus(root, 'Link kopyalandı');
          } catch (error) {
            showStatus(root, 'Linki kopyalamaq olmadı');
          }
        }
        return;
      }

      closeAllMenus();
    }

    document.addEventListener('click', handleStoryShareClick, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllMenus();
    });
    document.addEventListener('shopify:section:load', scheduleShareAlignment);
    window.addEventListener('resize', scheduleShareAlignment, { passive: true });
    window.addEventListener('load', scheduleShareAlignment, { once: true });
    scheduleShareAlignment();
  })();
